<div [matMenuTriggerFor]="menu" [ngClass]="mode()">
  @if (mode() !== 'small') {
    <span class="welcome">Welcome back to</span>
    <span class="label">Semeris Docs for</span>
    @if ((label() | readableList) || '<pick at least one>'; as label) {
      <div [semerisTooltip]="label">
        <span class="value">{{ label }}</span>
        <mat-icon class="drop-down-icon">arrow_drop_down</mat-icon>
      </div>
    }
  }

  @if (mode() === 'small') {
    <mat-icon>web_asset</mat-icon>
  }
</div>

<mat-menu #menu="matMenu" class="asset-selector-panel" (closed)="onClosed($event)">
  <div class="title">
    <span class="title-name">Asset classes</span>
    <semeris-help-icon helpId="asset-switching.html"></semeris-help-icon>
  </div>
  @for (option of options(); track option) {
    <button
      [class.active]="option.selected"
      [disabled]="!option.fromTenant"
      class="asset-option"
      mat-menu-item
      (click)="onAssetClicked(option.assetShortName)">
      <div>
        {{ option.displayName }}
        @if (!option.fromTenant) {
          <span>(Contact sales)</span>
        }
      </div>
      @if (option.fromTenant) {
        <mat-checkbox
          [disabled]="!option.fromTenant"
          [checked]="option.selected"
          (click)="onValueChanged(option.assetShortName, $event)"></mat-checkbox>
      }
    </button>
  }

  <div class="save-btn">
    <button type="button" semerisButton color="accent" [disabled]="!hasSelectedAssets()" (click)="save()">
      Apply changes
    </button>
  </div>
</mat-menu>
